<template>
  <div>
    <component
      :is="component"
      :popupParam="popupParam"
      :contentHeight="contentHeight"
      :count="count"
      @closePopup="closePopup"
      @changeStatus="changeStatus"
      @transInfo="transInfo"
    />
    <!-- <c-tab
      ref="ctomissTab"
      type="horizon"
      :inlineLabel="true"
      :dense="true"
      :height="tabHeight"
      :tabItems="tabItems"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :contentHeight="contentHeight"
          :count="count"
          @closePopup="closePopup"
          @changeStatus="changeStatus"
          @transInfo="transInfo"
        />
      </template>
    </c-tab> -->
  </div>
      <!-- class="full-height" -->
</template>

<script>
export default {
  name: 'cto-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopCtoId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      component: () => import(`${'./ctoTab.vue'}`),
      height: '',
      editable: true,
      splitter: 5,
      tab: 'ctoTab',
      count: 0,
    };
  },
  computed: {
    // tabItems() {
    //   return [
    //     { name: 'ctoTab', icon: 'edit', label: '안전보건팀 패트롤 정보', component: () => import(`${'./ctoTab.vue'}`) },
    //     { name: 'ctoCausePrevention', icon: 'auto_fix_normal', label: '방지 및 감소대책', component: () => import(`${'./ctoCausePrevention.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true)  },
    //   ]
    // },
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
    transInfo(data) {
      this.popupParam.sopCtoId = data.sopCtoId;
    },
    changeStatus(data) {
      this.popupParam.sopCtoId = data.sopCtoId;
    },
    tabClick() {
      this.count++;
    }
  }
};
</script>
